export const HUBSPOT = 'HUBSPOT';
export const APP_PARTNER = 'APP_PARTNER';